/* ── BV Added-to-Cart Toast ─────────────────────────────────────── */
(function () {
  if (document.getElementById('bv-cart-toast')) return;

  // Inject toast HTML + CSS once
  const style = document.createElement('style');
  style.textContent = `
    #bv-cart-toast {
      position: fixed;
      bottom: 2rem;
      left: 50%;
      transform: translateX(-50%) translateY(120%);
      z-index: 999999;
      background: #111;
      color: #fff;
      font-family: inherit;
      font-size: 1rem;
      font-weight: 600;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      padding: 1rem 2rem;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.22);
      display: flex;
      align-items: center;
      gap: 0.7rem;
      white-space: nowrap;
      pointer-events: none;
      transition: transform 0.32s cubic-bezier(0.16,1,0.3,1), opacity 0.32s ease;
      opacity: 0;
    }
    #bv-cart-toast.bv-toast--show {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
      pointer-events: auto;
    }
    #bv-cart-toast .bv-toast-icon {
      width: 1.3rem;
      height: 1.3rem;
      background: #4caf50;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #bv-cart-toast .bv-toast-icon svg {
      width: 0.7rem;
      height: 0.7rem;
    }
  `;
  document.head.appendChild(style);

  const toast = document.createElement('div');
  toast.id = 'bv-cart-toast';
  toast.innerHTML = `
    <span class="bv-toast-icon">
      <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 6L5 9L10 3" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <span class="bv-toast-msg">Added to bag</span>
  `;
  document.body.appendChild(toast);

  let toastTimer;
  window.bvShowCartToast = function (msg) {
    const msgEl = toast.querySelector('.bv-toast-msg');
    if (msgEl) msgEl.textContent = msg || 'Added to bag';
    clearTimeout(toastTimer);
    toast.classList.add('bv-toast--show');
    toastTimer = setTimeout(() => toast.classList.remove('bv-toast--show'), 2600);
  };

  // Update cart bubble count
  window.bvUpdateCartCount = function () {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart__count').forEach(el => {
          el.textContent = count;
          if (count > 0) el.closest('[aria-label*="art"]')?.removeAttribute('hidden');
        });
        // Dawn-specific bubble
        const bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(b => {
          b.querySelector('span[aria-hidden]').textContent = count;
          if (count > 0) b.removeAttribute('hidden');
        });
      })
      .catch(() => {});
  };
})();

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        // Restore body scroll immediately
        document.body.classList.remove('overflow-hidden');
        document.body.style.overflow = '';
        document.body.style.touchAction = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        // Lock body scroll IMMEDIATELY before fetch
        document.body.classList.add('overflow-hidden');
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList?.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info') || responseHTML.querySelector('product-component') || responseHTML.querySelector('.product') || responseHTML.querySelector('section[id^="MainProduct-"]');

            if (productElement) {
              // Strip all junk before injecting
              const junkSelectors = [
                '.product__media-wrapper', '.product__tax', '.installment',
                '.product__text', '.product__inventory', '.share-button',
                '.product__description', '.product__accordion', '.product-form__quantity',
                '.bv-buy-sep-container', '.shopify-payment-button', 'pickup-availability',
                '.volume-pricing-note', '.product-disclosures', '.product__sku',
                '.rating', 'noscript', '.trust-badge', '.product-popup-modal',
                'modal-opener', '.product__view-details', '.complementary-products',
                '.product-recommendations', '.payment-terms', '.payment__icon',
                '.product__selling-plan-group', '.secure-payment', '.product-form__input--payment',
                '[class*="payment"]'
              ];
              junkSelectors.forEach(sel => {
                productElement.querySelectorAll(sel).forEach(el => el.remove());
              });

              this.preprocessHTML(productElement);
              HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

              // ── Wire up AJAX Add to Cart ──────────────────────────────
              this._attachCartSubmit();
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

            // Don't call super.show() — it would re-add overflow-hidden and
            // do trapFocus which can fight the scroll lock we already set.
            this.openedBy = opener;
            this.setAttribute('open', '');
            trapFocus(this, this.querySelector('[role="dialog"]'));
            window.pauseAllMedia();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList?.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      _attachCartSubmit() {
        const modal = this;
        // Use event delegation on modalContent so it works after DOM replacement
        const handler = (e) => {
          const btn = e.target.closest('button[name="add"], .product-form__submit');
          if (!btn) return;
          e.preventDefault();
          e.stopImmediatePropagation();

          const form = btn.closest('form');
          if (!form) return;

          // Show loading state on button
          const origText = btn.innerHTML;
          btn.disabled = true;
          btn.innerHTML = '<span style="opacity:0.7">Adding...</span>';

          const formData = new FormData(form);
          formData.append('sections', '');
          formData.append('sections_url', window.location.pathname);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          })
            .then(res => res.json())
            .then(data => {
              if (data.status && data.status !== 200) {
                // Error (e.g. sold out)
                btn.innerHTML = origText;
                btn.disabled = false;
                if (window.bvShowCartToast) bvShowCartToast(data.description || 'Something went wrong');
                return;
              }
              // Success — close modal and show toast
              modal.hide(true);
              if (window.bvShowCartToast) bvShowCartToast('Added to bag');
              if (window.bvUpdateCartCount) bvUpdateCartCount();
            })
            .catch(() => {
              btn.innerHTML = origText;
              btn.disabled = false;
              if (window.bvShowCartToast) bvShowCartToast('Could not add item');
            });
        };

        // Remove any previous listener and re-attach
        this.modalContent.removeEventListener('click', this._cartHandler);
        this._cartHandler = handler;
        this.modalContent.addEventListener('click', this._cartHandler);
      }
    }
  );
}
